import debug from "debug";

import { getConfig, isServerSide } from "@jti/fe-common";

const log = debug("desjti:newRelic:noticeError");

export function isReady(): boolean {
  return !isServerSide() && Boolean(window.newrelic);
}

export function addRelease(releaseName: string, releaseId: string): void {
  if (isReady()) {
    window.newrelic.addRelease(releaseName, releaseId);
  }
}

export function noticeError(err: Error | string, customParams?: Record<string, string | number>): void {
  const error = err instanceof Error ? err : new Error(err);

  if (isReady() && getConfig().NEW_RELIC_NOTICE_ERROR === "true") {
    window.newrelic.noticeError(error, customParams);
  }

  log(`[${error.name}]${error.message}`, customParams);
}

export function sendWarning(message: string, customParams?: Record<string, string | number>): void {
  if (isReady()) {
    window.newrelic.addPageAction("Warning", {
      message,
      ...customParams,
    });
  }

  log(`[WARN] ${message}`, customParams);
}

export type NewRelicCustomAttributeValue = string | number | boolean;

const toSimpleType = (value: NewRelicCustomAttributeValue): string | number =>
  typeof value === "boolean" ? String(value) : value;

export function setCustomAttribute(name: string, value: NewRelicCustomAttributeValue): void {
  if (isReady()) {
    window.newrelic.setCustomAttribute(name, toSimpleType(value));
  }
}

export function setCustomAttributes(attributes: Record<string, NewRelicCustomAttributeValue | undefined>): void {
  if (!isReady()) {
    return;
  }

  for (const [name, value] of Object.entries(attributes)) {
    if (value === undefined) {
      continue;
    }
    window.newrelic.setCustomAttribute(name, toSimpleType(value));
  }
}
